export const isServer = (): boolean => !globalThis.window
